import { CPT_SLAB_META } from "../../DispatchDashboard/utils";
import { CityScope, STANDARD_CPT_SLAB_LEVEL } from "../types";

export interface DeliveryTypeTab {
  key: string;
  level: string;
  cityScope?: CityScope;
  label: string;
  subLabel?: string;
}

export const CPT_TAB_PRIORITY: Record<string, number> = {
  "1": 1,
  "2": 2,
  "-2": 3,
  "-1": 4,
};

export const STANDARD_CITY_SCOPE_SUB_LABEL: Record<CityScope, string> = {
  intra: "(Intracity)",
  inter: "(Intercity)",
};

export function sortCptLevelKeys(levelKeys: string[]): string[] {
  return [...levelKeys].sort((a, b) => {
    const priorityA = CPT_TAB_PRIORITY[a] ?? 99;
    const priorityB = CPT_TAB_PRIORITY[b] ?? 99;
    return priorityA - priorityB;
  });
}

export function buildDeliveryTypeTabs(
  sortedLevelKeys: string[],
  labels?: Record<string, string> | null,
): DeliveryTypeTab[] {
  const tabs: DeliveryTypeTab[] = [];

  sortedLevelKeys.forEach((level) => {
    const label = labels?.[level] || CPT_SLAB_META[level]?.fallbackLabel || "?";

    if (Number(level) === STANDARD_CPT_SLAB_LEVEL) {
      tabs.push({
        key: `${level}-intra`,
        level,
        cityScope: "intra",
        label,
        subLabel: STANDARD_CITY_SCOPE_SUB_LABEL.intra,
      });
      tabs.push({
        key: `${level}-inter`,
        level,
        cityScope: "inter",
        label,
        subLabel: STANDARD_CITY_SCOPE_SUB_LABEL.inter,
      });
      return;
    }

    tabs.push({
      key: level,
      level,
      label,
    });
  });

  return tabs;
}

export function getActiveDeliveryTabIndex(
  tabs: DeliveryTypeTab[],
  activeCptTab: string,
  cityScope: CityScope,
): number {
  const index = tabs.findIndex((tab) => {
    if (tab.level !== activeCptTab) {
      return false;
    }
    if (tab.cityScope) {
      return tab.cityScope === cityScope;
    }
    return true;
  });

  return Math.max(0, index);
}
